/* =============================================================
   FUTUR FLARE — Hero 3D v3 (FF or poli · cinématique · max wow)
   - Logo FF extrudé en or poli (MeshPhysicalMaterial clearcoat)
   - Entry burst : scale 0→1, rotation 720°, rings expand, particles burst
   - Idle : rotation auto lente + parallax mousemove + tilt scroll
   - 3 anneaux en contra-rotation + 350 particules orbitales
   - Fake bloom via CSS drop-shadow multi-layer
   ============================================================= */
(function () {
  'use strict';

  if (!window.THREE) return;
  const container = document.querySelector('[data-ff-hero-three]');
  if (!container) return;

  const env = (window.FF && window.FF.env) || {};
  const prefersReducedMotion = env.prefersReducedMotion;
  const isCoarsePointer     = env.isCoarsePointer;
  const isLowEnd            = env.isLowEnd;

  function hasWebGL() {
    try {
      const c = document.createElement('canvas');
      return !!(window.WebGLRenderingContext && (c.getContext('webgl') || c.getContext('experimental-webgl')));
    } catch (e) { return false; }
  }
  if (!hasWebGL() || prefersReducedMotion || isLowEnd) {
    container.setAttribute('data-ff-three-status', 'fallback');
    return;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    requestAnimationFrame(init);
  }

  function init() {
    const THREE = window.THREE;
    const width  = () => container.clientWidth;
    const height = () => container.clientHeight;

    // --- Scene + camera + renderer ---
    const scene = new THREE.Scene();
    scene.fog = new THREE.FogExp2(0x0A0A0B, 0.015);

    function isMobile() { return window.innerWidth < 768; }
    const camera = new THREE.PerspectiveCamera(isMobile() ? 58 : 42, width() / Math.max(height(),1), 0.1, 100);
    camera.position.set(0, 0, isMobile() ? 6.8 : 5.8);

    const renderer = new THREE.WebGLRenderer({
      antialias: window.devicePixelRatio < 2,
      alpha: true,
      powerPreference: 'high-performance'
    });
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
    renderer.setSize(width(), height());
    renderer.setClearColor(0x000000, 0);
    if (THREE.ACESFilmicToneMapping !== undefined) {
      renderer.toneMapping = THREE.ACESFilmicToneMapping;
      renderer.toneMappingExposure = 1.35;
    }
    if (THREE.sRGBEncoding !== undefined) {
      renderer.outputEncoding = THREE.sRGBEncoding;
    }
    renderer.domElement.style.position = 'absolute';
    renderer.domElement.style.inset = 0;
    renderer.domElement.style.width = '100%';
    renderer.domElement.style.height = '100%';
    // Fake bloom multi-layer drop-shadow (wow effect sans postprocessing)
    renderer.domElement.style.filter = [
      'drop-shadow(0 0 18px rgba(201,169,97,0.55))',
      'drop-shadow(0 0 40px rgba(201,169,97,0.35))',
      'drop-shadow(0 0 80px rgba(201,169,97,0.18))'
    ].join(' ');
    container.appendChild(renderer.domElement);

    // --- Lighting multi-source (or poli = besoin de reflections multiples) ---
    scene.add(new THREE.HemisphereLight(0xfff0d0, 0x1a1510, 0.45));

    const keyLight = new THREE.DirectionalLight(0xffffff, 2.2);
    keyLight.position.set(5, 7, 6);
    scene.add(keyLight);

    const warmLight = new THREE.PointLight(0xC9A961, 3.5, 18);
    warmLight.position.set(-4, -1, 4);
    scene.add(warmLight);

    const backLight = new THREE.PointLight(0xE3C684, 2.5, 22);
    backLight.position.set(0, 4, -5);
    scene.add(backLight);

    const rim = new THREE.SpotLight(0xffd78a, 2.8, 15, Math.PI / 6, 0.6, 1);
    rim.position.set(0, 8, 4);
    rim.target.position.set(0, 0, 0);
    scene.add(rim);
    scene.add(rim.target);

    // --- Matériau or poli (full premium) ---
    const GOLD = 0xC9A961;
    const goldMat = new THREE.MeshPhysicalMaterial({
      color: GOLD,
      metalness: 1.0,
      roughness: 0.18,
      clearcoat: 1.0,
      clearcoatRoughness: 0.04,
      reflectivity: 0.9,
      emissive: 0x3a2a10,
      emissiveIntensity: 0.25
    });

    // --- Lettre F via Shape + ExtrudeGeometry ---
    function buildFGeometry() {
      const s = new THREE.Shape();
      s.moveTo(-0.55, -1.05);
      s.lineTo(-0.55,  1.05);
      s.lineTo( 0.55,  1.05);
      s.lineTo( 0.55,  0.75);
      s.lineTo(-0.25,  0.75);
      s.lineTo(-0.25,  0.12);
      s.lineTo( 0.35,  0.12);
      s.lineTo( 0.35, -0.18);
      s.lineTo(-0.25, -0.18);
      s.lineTo(-0.25, -1.05);
      s.closePath();
      const geo = new THREE.ExtrudeGeometry(s, {
        depth: 0.32,
        bevelEnabled: true,
        bevelSegments: 8,
        steps: 2,
        bevelSize: 0.045,
        bevelThickness: 0.045,
        curveSegments: 12
      });
      geo.center();
      return geo;
    }

    const logoGroup = new THREE.Group();
    const fGeo = buildFGeometry();

    const f1 = new THREE.Mesh(fGeo, goldMat);
    f1.position.x = -1.0;
    logoGroup.add(f1);

    const f2 = new THREE.Mesh(fGeo, goldMat);
    f2.position.x = 1.0;
    logoGroup.add(f2);

    // Dot central (sphère)
    const dotMesh = new THREE.Mesh(
      new THREE.SphereGeometry(0.12, 32, 32),
      goldMat
    );
    dotMesh.position.set(0, 0, 0.16);
    logoGroup.add(dotMesh);

    scene.add(logoGroup);

    // --- 3 anneaux en contra-rotation ---
    const outerRing = new THREE.Mesh(
      new THREE.TorusGeometry(2.8, 0.035, 20, 180),
      new THREE.MeshPhysicalMaterial({
        color: GOLD,
        metalness: 1.0,
        roughness: 0.2,
        clearcoat: 0.8,
        emissive: 0x3a2a10,
        emissiveIntensity: 0.3
      })
    );
    outerRing.rotation.x = Math.PI / 3;
    scene.add(outerRing);

    const midRing = new THREE.Mesh(
      new THREE.TorusGeometry(2.1, 0.018, 16, 140),
      new THREE.MeshBasicMaterial({
        color: 0xE3C684,
        transparent: true,
        opacity: 0.55
      })
    );
    midRing.rotation.x = Math.PI / 2.3;
    midRing.rotation.y = Math.PI / 6;
    scene.add(midRing);

    const innerRing = new THREE.Mesh(
      new THREE.TorusGeometry(1.65, 0.008, 12, 120),
      new THREE.MeshBasicMaterial({
        color: 0xF4E8C4,
        transparent: true,
        opacity: 0.35
      })
    );
    innerRing.rotation.x = Math.PI / 2.7;
    innerRing.rotation.z = Math.PI / 4;
    scene.add(innerRing);

    // --- Particules orbitales (gold dust additive) ---
    const particleCount = 350;
    const positions = new Float32Array(particleCount * 3);
    for (let i = 0; i < particleCount; i++) {
      const r = 2.6 + Math.random() * 2.5;
      const theta = Math.random() * Math.PI * 2;
      const phi = Math.acos(2 * Math.random() - 1);
      positions[i * 3 + 0] = r * Math.sin(phi) * Math.cos(theta);
      positions[i * 3 + 1] = r * Math.sin(phi) * Math.sin(theta);
      positions[i * 3 + 2] = r * Math.cos(phi);
    }
    const partGeo = new THREE.BufferGeometry();
    partGeo.setAttribute('position', new THREE.BufferAttribute(positions, 3));
    const partMat = new THREE.PointsMaterial({
      color: GOLD,
      size: 0.045,
      sizeAttenuation: true,
      transparent: true,
      opacity: 0.8,
      blending: THREE.AdditiveBlending,
      depthWrite: false
    });
    const particles = new THREE.Points(partGeo, partMat);
    scene.add(particles);

    // --- Parallax mouse + scroll ---
    let mx = 0, my = 0, tx = 0, ty = 0;
    let scrollY = 0;

    if (!isCoarsePointer) {
      window.addEventListener('pointermove', (e) => {
        const r = container.getBoundingClientRect();
        mx = ((e.clientX - r.left) / Math.max(r.width,1) - 0.5) * 2;
        my = ((e.clientY - r.top)  / Math.max(r.height,1) - 0.5) * 2;
      }, { passive: true });
    }
    window.addEventListener('scroll', () => {
      scrollY = window.scrollY / Math.max(window.innerHeight, 1);
    }, { passive: true });

    // --- Entry burst (wow) ---
    logoGroup.scale.set(0, 0, 0);
    outerRing.scale.set(0, 0, 0);
    midRing.scale.set(0, 0, 0);
    innerRing.scale.set(0, 0, 0);
    particles.visible = false;

    const entryStart = performance.now();
    const entryDur = 1800;

    function lerp(a, b, t) { return a + (b - a) * t; }
    function easeOutQuart(t) { return 1 - Math.pow(1 - t, 4); }
    function easeOutBack(t) {
      const c1 = 1.70158, c3 = c1 + 1;
      return 1 + c3 * Math.pow(t - 1, 3) + c1 * Math.pow(t - 1, 2);
    }

    function runEntry(now) {
      const p = Math.min(1, (now - entryStart) / entryDur);

      // Logo : scale avec bounce + spin 720°
      const logoP = Math.min(1, p / 0.85);
      const logoScale = Math.max(0, easeOutBack(logoP));
      logoGroup.scale.setScalar(logoScale);
      logoGroup.rotation.y = (1 - logoP) * Math.PI * 4;

      // Rings staggered expand
      if (p > 0.15) {
        outerRing.scale.setScalar(easeOutQuart(Math.min(1, (p - 0.15) / 0.7)));
      }
      if (p > 0.25) {
        midRing.scale.setScalar(easeOutQuart(Math.min(1, (p - 0.25) / 0.65)));
      }
      if (p > 0.35) {
        innerRing.scale.setScalar(easeOutQuart(Math.min(1, (p - 0.35) / 0.6)));
      }
      // Particles fade-in
      if (p > 0.6) {
        particles.visible = true;
        partMat.opacity = lerp(0, 0.8, (p - 0.6) / 0.4);
      }
      return p < 1;
    }

    // --- Main loop ---
    let running = true;
    document.addEventListener('visibilitychange', () => { running = !document.hidden; });

    const clock = new THREE.Clock();
    function tick() {
      if (running) {
        const now = performance.now();
        const elapsed = clock.getElapsedTime();
        const inEntry = runEntry(now);

        // Parallax smoothing
        tx += (mx * 0.35 - tx) * 0.06;
        ty += (my * 0.22 - ty) * 0.06;

        // Idle rotations après entry
        if (!inEntry) {
          logoGroup.rotation.y = elapsed * 0.22 + tx * 0.8;
          logoGroup.rotation.x = Math.sin(elapsed * 0.35) * 0.08 + ty * 0.35;
          logoGroup.rotation.z = Math.sin(elapsed * 0.25) * 0.03;
        }

        // Rings contra-rotation
        outerRing.rotation.z = elapsed * 0.08;
        outerRing.rotation.x = Math.PI / 3 + Math.sin(elapsed * 0.3) * 0.06;
        midRing.rotation.z = -elapsed * 0.14;
        midRing.rotation.y = Math.PI / 6 + elapsed * 0.04;
        innerRing.rotation.z = elapsed * 0.22;
        innerRing.rotation.x = Math.PI / 2.7 + Math.sin(elapsed * 0.45) * 0.1;

        // Particles gentle orbit
        particles.rotation.y = elapsed * 0.035 + tx * 0.12;
        particles.rotation.x = -elapsed * 0.02 + ty * 0.05;

        // Camera parallax + scroll tilt
        camera.position.x = tx * 0.6;
        camera.position.y = -ty * 0.35 - scrollY * 0.8;
        camera.position.z = (isMobile() ? 6.8 : 5.8) - scrollY * 0.6;
        camera.lookAt(0, 0, 0);

        renderer.render(scene, camera);
      }
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);

    // --- Resize handler (FOV responsive) ---
    window.addEventListener('resize', () => {
      camera.aspect = width() / Math.max(height(), 1);
      camera.fov = isMobile() ? 58 : 42;
      camera.position.z = isMobile() ? 6.8 : 5.8;
      camera.updateProjectionMatrix();
      renderer.setSize(width(), height());
    });

    // --- Cache le fallback CSS (ring + FF statique) quand 3D ready ---
    const cssRing = document.querySelector('.ff-hero__ring');
    if (cssRing) cssRing.style.display = 'none';

    container.setAttribute('data-ff-three-status', 'ready');

    // Canvas visible direct (l'entry burst scale 0→1 fait déjà le wow).
    renderer.domElement.style.opacity = '1';
  }
})();
